import { render, staticRenderFns } from "./PpeApplyRecordHistoryList.vue?vue&type=template&id=651f4a85&"
import script from "./PpeApplyRecordHistoryList.vue?vue&type=script&lang=js&"
export * from "./PpeApplyRecordHistoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports